module.exports = __webpack_public_path__ + "static/media/czujnik0.2f1d83b1.svg";